export default {
	getSearchData_({ state }) {
		return state.searchParams;
	},
	//사용여부 selectBox
	getUseYnList_({ useYnList }) {
		const list = [];
		useYnList.length && useYnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사항목 selectBox
	getCkuPrvsList_({ ckuPrvsList }) {
		const list = [];
		ckuPrvsList.length && ckuPrvsList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사방법 selectBox
	getCkuWayList_({ ckuWayList }) {
		const list = [];
		ckuWayList.length && ckuWayList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사방법 selectBox
	getCkuWayList2_({ ckuWayList2 }) {
		// const list = [];
		// ckuWayList2.length && ckuWayList2.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		// console.log('ckuWayList >>>2 ', ckuWayList2);
		return ckuWayList2;
	},
	//단위 selectBox
	getUtmList_({ utmList }) {
		const list = [];
		utmList.length && utmList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//판정기준 selectBox
	getJgmtCrtnList_({ jgmtCrtnList }) {
		const list = [];
		jgmtCrtnList.length && jgmtCrtnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//합불기준 selectBox
	getPassDsqfList_({ passDsqfList }) {
		const list = [];
		passDsqfList.length && passDsqfList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//사용여부(상세쪽) selectBox
	getUseYnDtlList_({ useYnDtlList }) {
		const list = [];
		useYnDtlList.length && useYnDtlList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},

	// 그리드에서 체크된 것이 있는지 count확인
	// getGridCheckCount({}){

	// }
	//부품검사 항목 상세 추가시 왼쪽에 선택된 검사항목이 있는지 확인
	getLeftItemSelectedYn_({ currentMstValue }) {
		let selYn = 'N';
		//console.log(currentMstValue.partNo);
		if (currentMstValue.partNo != '') {
			selYn = 'Y';
		}
		return selYn;
	}
};
